export default __webpack_public_path__ + "static/realWorldImg5-5729704ef86806fbd767811387b59f46.webp";